<template>
  <!-- most of main.css scopes styling under #booking-widget <descendant>, so this
       wrapper keeps that CSS matching once the modal is teleported out from under
       the real #booking-widget root into <body> -->
  <div id="booking-widget">
  <div class="modal" id="modalbookingForm">
    <div class="modal-dialog">
      <div class="modal-header">
        <div class="modal-title">
          <h4>Book Your</h4>
          <h1>{{ $parent.roomLabel.plural }}</h1>
        </div>
        <button type="button" id="btn_close" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div id="vue-smallScreen" class="bookingsm" v-show="$parent.spinner">
            <div class="row">
              <div class="col-md-12">
                <div class="mobilelabel" v-if="$parent.multipropertyStatus == true">
                  <label>Destination</label>
                  <select class="form-control vue-small_large_select smallrooms"
                    @click="$parent.updateRoomFilter($parent.multiproperties)" v-model="$parent.destination">
                    <option :value="$parent.initialPropertyId">{{ $parent.initialPropertyName }}</option>
                    <option :value="pdestination.id" v-for="(pdestination, destindex) in $parent.multiproperties.filter(p => p.id !== $parent.initialPropertyId)"
                      :key="destindex">
                      {{ pdestination.propertyName }}
                    </option>
                  </select>
                </div>
                <div class="mobilelabel">
                  <span>Arrival Date</span>
                  <CheckinDate
                    :stayrestrictions="$parent.bookings.data && $parent.bookings.data[$parent.propertyid] ? $parent.bookings.data[$parent.propertyid].stay_restrictions : []"
                    @checkin-date-changed="$parent.checkAvailabilty('sa')"></CheckinDate>
                </div>
                <div class="mobilelabel">
                  <span>Departure Date</span>
                  <CheckoutDate
                    :stayrestrictions="$parent.bookings.data && $parent.bookings.data[$parent.propertyid] ? $parent.bookings.data[$parent.propertyid].stay_restrictions : []"
                    @checkout-date-changed="$parent.checkAvailabilty('sa')"></CheckoutDate>
                </div>
                <div class="mobilelabel">
                  <span id="checkinlbl">Occupancy</span>
                  <select class="form-control vue-small_large_select smallrooms" v-model="$parent.room">
                    <option value="1" selected="selected">
                      1 {{ $parent.roomLabel.singular }}
                    </option>
                    <option value="2">2 {{ $parent.roomLabel.plural }}</option>
                    <option value="3">3 {{ $parent.roomLabel.plural }}</option>
                    <option value="4">4 {{ $parent.roomLabel.plural }}</option>
                    <option value="5">5 {{ $parent.roomLabel.plural }}</option>
                    <option value="6">6 {{ $parent.roomLabel.plural }}</option>
                    <option value="7">7 {{ $parent.roomLabel.plural }}</option>
                    <option value="8">8 {{ $parent.roomLabel.plural }}</option>
                    <option value="9">9 {{ $parent.roomLabel.plural }}</option>
                    <option value="10">10 {{ $parent.roomLabel.plural }}</option>
                  </select>
                  <div id="smallcapacity">
                    <select class="form-control vue-small_large_select" v-model="$parent.defaultAdultNo">
                      <option value="1" selected="selected">1 ADULT</option>
                      <option value="2">2 ADULTS</option>
                      <option value="3">3 ADULTS</option>
                      <option value="4">4 ADULTS</option>
                      <option value="5">5 ADULTS</option>
                      <option value="6">6 ADULTS</option>
                      <option value="7">7 ADULTS</option>
                      <option value="8">8 ADULTS</option>
                      <option value="9">9 ADULTS</option>
                      <option value="10">10 ADULTS</option>
                    </select>

                    <select class="form-control vue-small_large_select" id="occ_children_s"
                      v-model="$parent.defaultChildrenNo" v-if="$parent.ageGroupsDetails.children_allowed != 0"
                      @change="$parent.addChildMobile()">
                      <option value="0" selected="selected">0 CHILDREN</option>
                      <option value="1">1 CHILD</option>
                      <option value="2">2 CHILDREN</option>
                      <option value="3">3 CHILDREN</option>
                      <option value="4">4 CHILDREN</option>
                      <option value="5">5 CHILDREN</option>
                      <option value="6">6 CHILDREN</option>
                      <option value="7">7 CHILDREN</option>
                      <option value="8">8 CHILDREN</option>
                      <option value="9">9 CHILDREN</option>
                      <option value="10">10 CHILDREN</option>
                    </select>
                    <div class="col-md-12" v-if="$parent.children > 0">
                      <div id="vue-ageDiv">
                        <label id="age_label">Please select the child's age. Children
                          are considered to be between
                          {{ $parent.ageGroupsDetails.child_min_age }} and
                          {{
                          $parent.ageGroupsDetails.child_max_age
                          }}
                          years.</label>
                        <div class="child_div" v-for="child in $parent.children" :key="child">
                          <label>Child {{ child }}</label>
                          <select id="child_1_age" name="child_1_age" class="child_ages rounded5" v-on:change="
                                      $parent.updateChildAges($event, child)
                                    ">
                            <option value="">Age</option>
                            <option v-for="(
                                        childrenagerange, ageindex
                                      ) in $parent.computeChildrenAgeRange(
                                        $parent.ageGroupsDetails
                                      )" :key="ageindex" :value="childrenagerange.age">
                              {{ childrenagerange.age }} yrs
                            </option>
                          </select>
                        </div>

                      </div>
                      <div v-if="$parent.ageError" style="color:red">
                        <small>Please Fill the Child(ren) Age(s)</small>
                      </div>

                    </div>
                    <select id="occ_babies_s" class="form-control vue-small_large_select" v-model="$parent.defaultbabiesNo"
                      v-if="$parent.ageGroupsDetails.babies_allowed != 0">
                      <option value="0" selected="selected">0 BABIES</option>
                      <option value="1">1 BABY</option>
                      <option value="2">2 BABIES</option>
                      <option value="3">3 BABIES</option>
                      <option value="4">4 BABIES</option>
                      <option value="5">5 BABIES</option>
                      <option value="6">6 BABIES</option>
                      <option value="7">7 BABIES</option>
                      <option value="8">8 BABIES</option>
                      <option value="9">9 BABIES</option>
                      <option value="10">10 BABIES</option>
                    </select>
                  </div>
                </div>
                <div class="mobilelabel" v-if="$parent.clientemail">
                  <span id="emaillbl">Your Email</span>
                  <input id="email_vue-smallScreen" class="vue-email_screen input-clearbg"
                    placeholder="Your email address" type="text" v-model="$parent.email" />
                </div>
                <div class="mobilelabel">
                  <span class="mobilelabel">Promo Code</span>
                  <input type="text" id="coupon_code_vue-smallScreen" class="form-control coupon_code_screen"
                    placeholder="Promo code" v-model="$parent.promo" />
                </div>
                <button id="vue-btn-search-mobile" v-on:click.prevent="$parent.checkAvailabilty('s')"
                  @click="$parent.scrollToElement" class="btn btn-orange-solid">
                  <div v-show="$parent.isSearching">
                    <span v-html="$parent.searchspinner"></span>
                  </div>
                  <div v-show="!$parent.isSearching">Check Availabilty</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import CheckinDate from './dates/checkinDate.vue'
import CheckoutDate from './dates/checkoutDate.vue'

export default {
  name: 'MobileSearchModal',
  components: { CheckinDate, CheckoutDate },
  beforeDestroy () {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MobileSearchModal.vue